import LeaveCreate from "@/controllers/leave/leave-create";
import axios from "axios";

export default {
    extends: LeaveCreate,
    data() {
        return {
            leaveData: {
                teacher_id: null,
                student_id: null,
                class_id: null,
                period: null,
                leave_reason: '',
                from_date: '',
                to_date: '',
                request_date: '',
                remark: '',
                status: '0',
                login_id:  this.$store.state.user.id,
                img_paths: []
            },
        }
    },
    methods: {
        changeClassEvent($class_id) {
            if (!this.auth('teacher').check()) {
                this.leaveData.teacher_id = 0;
            }
            this.leaveData.subject_id = 0;
            this.getTeacher($class_id);
            this.getStudentByClass($class_id);
        },
        getClass($yearId) {
            // For teachers, use getGradeAndClass which filters to homeroom/assistant classes
            if (this.auth('teacher').check()) {
                axios.get("class/getGradeAndClass", {
                    params: {
                        campus_id: this.$store.state.user.campus_id,
                    }
                })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class'
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace("login");
                    }
                    this.isLoading = false;
                });
                return;
            }

            // For admin, use the default class list endpoint
            axios.get("class/classList/" + $yearId, {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                }
            })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class'
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace("login");
                    }
                    this.isLoading = false;
                });
        },
        getTeacher($class_id) {
            if (this.auth('teacher').check()) return;

            this.teacher_id = 0;
            this.subject_id = 0;
            axios.get('/teacher/getTeacherByClass/' + $class_id)
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Teacher'
                    }];
                    this.teacherArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },
    },
    mounted() {
        if (this.auth('teacher').check()) {
            this.leaveData.teacher_id = this.$store.state.user.id;
        }
    }
};
